import { Injectable } from '@angular/core';
import { AlarisApiService } from '@campaign-portal/components-library';
import { MDTaskResult } from '@helpers/types/models';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ManualDippingErrorsTableService {
	readonly loading$ = new BehaviorSubject<boolean>(false);

	pageParams = {
		limit: 25,
		activePage: 0
	};

	filters: { key: string; value: any }[] = [];
	sortingDefault = {
		active: 'md_task_id',
		direction: 'asc'
	};
	sorting = structuredClone(this.sortingDefault);

	constructor(private readonly api: AlarisApiService) {}

	loadResult(id: number): Observable<{ data: MDTaskResult[]; length: number }> {
		const params = {
			offset: this.pageParams.activePage * this.pageParams.limit,
			limit: this.pageParams.limit,
			active: this.sorting.active,
			direction: this.sorting.direction,
			filter: [
				{
					key: 'md_task_id',
					value: id.toString()
				},
				{
					key: 'result',
					value: '1'
				},
				...this.filters
			]
		};
		return this.api.loader<{ data: MDTaskResult[]; length: number }>('MDResults.Read', params, this.loading$);
	}
}
